var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { failure, success } from '@devexperts/remote-data-ts';
import { asks } from 'fp-ts/lib/Reader';
import { of } from 'rxjs';
import { toRemoteData } from '../../utils/axios';
import { mapRD } from '../../utils/object.utils';
var JiraValidationError = /** @class */ (function (_super) {
    __extends(JiraValidationError, _super);
    function JiraValidationError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JiraValidationError.fromUnknown = function (e) {
        var error = e instanceof Error ? e.message : String(e);
        return new JiraValidationError(error);
    };
    return JiraValidationError;
}(Error));
export { JiraValidationError };
export var jira = asks(function (ctx) {
    var connectJira = function () {
        return { method: 'form' };
    };
    var completeConnectJira = function () {
        // tslint:disable-next-line: variable-name
        return new Promise(function (_resolve, reject) {
            reject(new Error('No token in the hash'));
        });
    };
    var getProjects = function (productId, integrationId) {
        return toRemoteData(ctx.axios.get("/api/products/" + productId + "/integrations/" + integrationId + "/jira-projects")).pipe(mapRD(function (projects) { return projects.map(normalizeJiraProject); }));
    };
    var testConnection = function (details) {
        try {
            new URL("https://" + details.host + "/rest/api/3/myself");
        }
        catch (e) {
            return of(failure(JiraValidationError.fromUnknown(e)));
        }
        return of(success(true));
        // TODO: an API call to actually verify the details
        /*return toRemoteData(
            Axios.get(url.href, {
                auth: {
                    username: details.username,
                    password: details.secrets.api_token,
                },
            }),
        ).pipe(map(result => result.mapLeft(JiraValidationError.fromUnknown)));*/
    };
    return {
        connect: connectJira,
        completeConnect: completeConnectJira,
        getProjects: getProjects,
        testConnection: testConnection,
    };
});
function normalizeJiraProject(project) {
    if ('key' in project) {
        return {
            project_key: project.key,
            project_name: project.name,
        };
    }
    return project;
}
//# sourceMappingURL=jira.service.js.map